<template>
  <v-col cols="12">
    <v-autocomplete
      label="Selecional Fiscal"
      v-model="formFilter.numeroUsuario"
      :items="listUsuarios"
      @change="listarEmpresas"
    ></v-autocomplete>
    <v-expand-transition>
      <v-autocomplete
        label="Selecional Empresa"
        v-model="formFilter.numeroEmpresa"
        :items="listEmpresas"
        v-if="listEmpresas.length > 0"
        @change="listarTarefas"
      ></v-autocomplete>
    </v-expand-transition>

    <MglMap
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      :zoom="zoom"
      :center="centerMap"
      style="width: 100%; height: 500px;"
      @load="onMapLoaded"
    >
      <MglMarker
        v-for="(tarefa, i) in listTarefas"
        :key="i"
        :coordinates="[tarefa.tarefa.longitude, tarefa.tarefa.latitude]"
        id="marker"
      >
        <div slot="marker">
          <img v-if="tarefa.usuario.foto" class="iconMglMarker" :src="tarefa.usuario.foto" style="object-fit: cover;" />
          <img v-else class="iconMglMarker" src="../assets/noimage.png" style="object-fit: cover;"/>
        </div>

        <MglPopup>
          <v-card>
            <v-card-text>
              <p>Nome da empresa: {{ tarefa.empresa.nomeFantasia }}</p>
              <p>Fiscal: {{ tarefa.usuario.nomeUsuario }}</p>
              <p>Cevs: {{ tarefa.endereco.cevs }}</p>
              <p>Endereço: {{ tarefa.endereco.endereco }}</p>
            </v-card-text>
          </v-card>
        </MglPopup>
      </MglMarker>
    </MglMap>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import { MglMap, MglPopup, MglMarker } from "vue-mapbox";
import "mapbox-gl/dist/mapbox-gl.css";

  let mapa = null


export default {
  components: {
    MglMap,
    MglPopup,
    MglMarker,
  },

  sockets: {
    reciveLocation: function (data) {
      console.log(data)
    }
  },

  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiZmVpb2t1biIsImEiOiJjanJtOWpsdzcwaDJsNDR0Mmh0ZGV1bzR2In0.XWAmqcgxDNyjq3Mg2XDE0g",
      mapStyle: "mapbox://styles/mapbox/streets-v11",
      coordinates: [-47.287163, -23.2695046],
      centerMap: [-47.287163, -23.2695046],
      listUsuarios: [],
      listEmpresas: [],
      listTarefas: [],
      zoom: 16,
      formFilter: {
        numeroUsuario: null,
        numeroEmpresa: null,
        dataInicial: null,
        dataFinal: null,
      },
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
    };
  },

  methods: {
    onMapLoaded: async function(map) {
      mapa = map.map;
      const tarefas = await axios.put("/tarefaDetalhada", this.formFilter, this.config);
      this.listTarefas = tarefas.data.filter((tarefa) => {
        return tarefa.tarefa.longitude != null;
      });

      mapa.flyTo({
        center: [
          this.listTarefas[this.listTarefas.length - 1].tarefa.longitude,
          this.listTarefas[this.listTarefas.length - 1].tarefa.latitude,
        ],
      });

      const listUsuarios = await axios.get("/usuarios", this.config);
      this.listUsuarios = listUsuarios.data.map((usuario) => {
        return {
          value: usuario.numeroUsuario,
          text: usuario.nomeUsuario,
        };
      });
    },

    async centralizarMapa() {
      mapa.flyTo({
        center: [
          this.listTarefas[this.listTarefas.length - 1].tarefa.longitude,
          this.listTarefas[this.listTarefas.length - 1].tarefa.latitude,
        ],
      });
    },

    async listarEmpresas() {

      await this.listarTarefas()

      const empresas = await axios.put("/listarEmpresasComTarefasPorUsuario", this.formFilter, this.config);
      this.listEmpresas = empresas.data.map((empresa) => {
        return {
          text: empresa.nomeFantasia,
          value: empresa.numeroEmpresa,
        };
      });
    },
    async listarTarefas() {
      const tarefas = await axios.put("/tarefaDetalhada", this.formFilter, this.config);
      this.listTarefas = tarefas.data.filter((tarefa) => {
        return tarefa.tarefa.longitude != null;
      });
      await this.centralizarMapa();
    },
  },
};
</script>

<style>
.iconMglMarker {
  width: 50px;
  height: 50px;
  display: block;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: -3px -2px 13px -6px rgba(253, 243, 198, 0.993);
  -webkit-box-shadow: -3px -2px 13px -6px rgba(253, 243, 198, 0.993);
  -moz-box-shadow: -3px -2px 13px -6px rgba(253, 243, 198, 0.993);
}
</style>